import type { Case, Event } from '@casetrace/shared';
import type { FilterState } from './filter-panel';
import type { TimelineRow } from './use-case-timeline';
import type { ToggleHighlightHandler } from '../../hooks/use-toggle-highlight';
import { CaseRoomHeader } from './case-room-header';
import { DateRangeBar } from './date-range-bar';
import { Timeline } from './timeline/timeline';
import { TimelineFilterBar } from './timeline/timeline-filter-bar';

interface CaseRoomMainColumnProps {
  caseId: string;
  caseItem: Case | undefined;
  filters: FilterState;
  starredCount: number;
  dateMin: string;
  dateMax: string;
  rows: TimelineRow[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  selectedId: string | null;
  expandedEvent: Event | null;
  highlightedEventIds: ReadonlySet<string>;
  canToggleHighlight: boolean;
  scrollToEventId?: string | null;
  onScrolledToEvent?: (eventId: string) => void;
  onFiltersChange: (filters: FilterState) => void;
  onSourcesClick: () => void;
  onSelect: (event: Event) => void;
  onDeselect: () => void;
  onToggleHighlight: ToggleHighlightHandler;
  fetchNextPage: () => void;
}

export function CaseRoomMainColumn({
  caseId,
  caseItem,
  filters,
  starredCount,
  dateMin,
  dateMax,
  rows,
  isLoading,
  isFetchingNextPage,
  hasNextPage,
  selectedId,
  expandedEvent,
  highlightedEventIds,
  canToggleHighlight,
  scrollToEventId = null,
  onScrolledToEvent,
  onFiltersChange,
  onSourcesClick,
  onSelect,
  onDeselect,
  onToggleHighlight,
  fetchNextPage,
}: CaseRoomMainColumnProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <CaseRoomHeader caseId={caseId} caseItem={caseItem} starredCount={starredCount} />
      <TimelineFilterBar filters={filters} onChange={onFiltersChange} />
      <DateRangeBar
        dateMin={dateMin}
        dateMax={dateMax}
        filters={filters}
        onChange={onFiltersChange}
      />
      <Timeline
        rows={rows}
        isLoading={isLoading}
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
        selectedId={selectedId}
        expandedEvent={expandedEvent}
        highlightedEventIds={highlightedEventIds}
        canToggleHighlight={canToggleHighlight}
        scrollToEventId={scrollToEventId}
        onScrolledToEvent={onScrolledToEvent}
        onSelect={onSelect}
        onDeselect={onDeselect}
        onToggleHighlight={onToggleHighlight}
        fetchNextPage={fetchNextPage}
        onOpenSources={onSourcesClick}
      />
    </div>
  );
}
